import { useClient } from 'components/ClientProvider';
import { useLoginHandler } from 'hooks/useLoginHandler';
import LandingPageContent from './LandingPageContent';

export const LandingPage = (): React.JSX.Element | null => {
  useLoginHandler()();
  const client = useClient();

  return (
    <>
      {(client?.headers['x-store-id'] !== '' &&
        client?.headers['x-enterprise-id'] !== '') ||
      client?.queryResult?.isError === true ? (
        <LandingPageContent />
      ) : null}
    </>
  );
};
